<template>
    <v-file-input
        truncate-length="30"
        show-size
        :label="itemAction.name"
        @change="selectFile"
        :accept="itemAction.accept"
        :value="value"
        outlined
        dense
        >
    </v-file-input>
</template>
<script>
export default {
  name: 'FileInputDinamicField',
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    currentFile: null,
    message: '',
    value: null
  }),
  mounted () {
    if (this.setterModel.documento_pdf) {
      const file = new File(['file'], this.setterModel.documento_pdf, { type: 'application/pdf' })
      // console.log(this.setterModel.documento_pdf)
      this.value = file
      this.onSuccess({ id: this.itemAction.nameid, data: file, fieldMain: this.itemAction })
    }
  },
  methods: {
    selectFile (file) {
      this.onSuccess({ id: this.itemAction.nameid, data: file, fieldMain: this.itemAction })
    }

  },
  watch: {
    setterModel (val) {
      // console.log('fff', val)
      if (val) {
        if (val.documento_pdf) {
          this.placeholder = this.setterModel.documento_pdf
        }
      }
    }
  }
}
</script>

<style></style>
